export default __webpack_public_path__ + "static/media/Festrahmentür N.d732f98f.jpg";